import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {FormErrorResponse} from '@/types'
import {HttpMedicalReportPayload, httpUpdateMedicalReport} from '@/features/medical-reports/http/medicalReports.http'

type UpdateMedicalReportPayload<T> = T extends {status: 'draft'} ? Partial<T> : T

export const useUpdateMedicalReport = <T extends HttpMedicalReportPayload>(
    medicalReportId: string,
    options?: UseMutationOptions<
        unknown,
        AxiosError<{errors: FormErrorResponse[]; code: string}>,
        UpdateMedicalReportPayload<T>
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.UPDATE_MEDICAL_REPORT],
        mutationFn: payload =>
            httpUpdateMedicalReport({
                urlParams: {medicalReportId},
                payload
            })
    })
}
